"use strict";
const React = require('react');
const react_redux_1 = require('react-redux');
const react_router_1 = require('react-router');
const FloatingActionButton_1 = require('material-ui/FloatingActionButton');
const add_1 = require('material-ui/svg-icons/content/add');
const tasks_1 = require('../actions/tasks');
const m = require('../models');
const selectors_1 = require('../selectors');
const routes = require('../utils/routes');
const AddTaskDialog_1 = require('./AddTaskDialog');
const Navigation_1 = require('./Navigation');
const Screen_1 = require('./Screen');
const TaskList_1 = require('./TaskList');
const mapStateToProps = (state) => ({
    tasks: selectors_1.tasksSelector(state),
    user: state.auth.user,
});
const mapDispatchToProps = (dispatch, props) => ({
    onAddTask: (task) => {
        dispatch(tasks_1.saveTask(selectors_1.viewTaskToTask(task))).then((task) => {
            react_router_1.browserHistory.push(routes.task(task.id));
        });
    },
});
class TasksScreen extends React.Component {
    constructor(props) {
        super(props);
        this.openAddTaskDialog = () => this.setState({ isAddTaskDialogOpen: true });
        this.closeAddTaskDialog = () => this.setState({ isAddTaskDialogOpen: false });
        this.handleAddTaskDialogSubmit = (name) => {
            const task = m.buildTask({ name });
            this.props.onAddTask(task);
            this.closeAddTaskDialog();
        };
        this.state = {
            isAddTaskDialogOpen: false,
        };
    }
    render() {
        return (React.createElement(Screen_1.Screen, null, 
            React.createElement(Navigation_1.default, null), 
            React.createElement(Screen_1.ScreenContent, null, 
                React.createElement(TaskList_1.default, {tasks: this.props.tasks})
            ), 
            React.createElement("div", {style: style.addTaskActionButtonContainer}, 
                React.createElement(FloatingActionButton_1.default, {onTouchTap: this.openAddTaskDialog}, 
                    React.createElement(add_1.default, null)
                )
            ), 
            React.createElement(AddTaskDialog_1.default, {isOpen: this.state.isAddTaskDialogOpen, onRequestClose: this.closeAddTaskDialog, onSubmit: this.handleAddTaskDialogSubmit})));
    }
}
const style = {
    addTaskActionButtonContainer: {
        position: 'absolute',
        right: '4%',
        bottom: '2.5%',
    },
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TasksScreen);



/** WEBPACK FOOTER **
 ** ./src/components/TasksScreen.tsx
 **/